module.exports = __webpack_public_path__ + "img/infographicWhoWeAreVerticalHome.e500b154.png";